var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.125 7.125C16.125 9.4032 14.2782 11.25 12 11.25C9.7218 11.25 7.875 9.4032 7.875 7.125C7.875 4.84682 9.7218 3 12 3C14.2782 3 16.125 4.84682 16.125 7.125ZM14.625 7.125C14.625 8.57475 13.4497 9.75 12 9.75C10.5503 9.75 9.375 8.57475 9.375 7.125C9.375 5.67525 10.5503 4.5 12 4.5C13.4497 4.5 14.625 5.67525 14.625 7.125Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12.75H9C6 12.75 4.5 14.25 4.5 18C4.5 19.5 8.25 21 12 21C15.75 21 19.5 19.5 19.5 18C19.5 14.25 18 12.75 15 12.75ZM6.74611 14.9653C7.10342 14.5633 7.73325 14.25 9 14.25H15C16.2668 14.25 16.8966 14.5633 17.2539 14.9653C17.6358 15.3949 17.979 16.2267 17.9991 17.8484C17.9738 17.8763 17.9355 17.9145 17.8793 17.9626C17.6372 18.1702 17.2133 18.4241 16.5991 18.6697C15.3807 19.1572 13.696 19.5 12 19.5C10.304 19.5 8.6193 19.1572 7.40083 18.6697C6.78667 18.4241 6.36284 18.1702 6.12072 17.9626C6.06449 17.9145 6.02623 17.8763 6.00093 17.8484C6.02103 16.2267 6.36417 15.3949 6.74611 14.9653ZM18.0429 17.792C18.0429 17.792 18.0416 17.7951 18.0376 17.8011C18.0407 17.795 18.0429 17.792 18.0429 17.792ZM5.95706 17.792C5.95706 17.792 5.95938 17.795 5.96246 17.8011C5.95835 17.7951 5.95706 17.792 5.95706 17.792Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconUser);
export default ForwardRef;